import React from 'react'
import SliderGallery from '../components/SliderGallery'



const CoolstepSandalwoodGallery = () => {

  const galleryImages = [

    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-3.jpg",
      alt:'Dec-Tec membrane in various applications and settings 1'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_65741670-Sandalwood.jpg",
      alt:'Dec-Tec membrane in various applications and settings 2'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-12.jpg",
      alt:'Dec-Tec membrane in various applications and settings 3'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-11.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 4'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-10.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 5'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-9.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 6'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-8.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 7'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-7.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 8'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-6.jpg",
      alt:'Dec-Tec membrane in various applications and settings 9'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-5.jpg",
      alt:'Dec-Tec membrane in various applications and settings 10'
    },

    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-4.jpg",
      alt:'Dec-Tec membrane in various applications and settings 23'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-2.jpg",
      alt:'Dec-Tec membrane in various applications and settings 24'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-Sandalwood-1.jpg",
      alt:'Dec-Tec membrane in various applications and settings 25'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/COOLSTEP-SANDALWOOD-2-edt-1.jpg",
      alt:'Dec-Tec membrane in various applications and settings 26'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_151480473-Sandalwood.jpg",
      alt:'Dec-Tec membrane in various applications and settings 27'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_100199276-Sandalwood.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 28'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_69012624-Sandalwood.jpg",
      alt:'Dec-Tec membrane in various applications and settings 29'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_4116803-Sandalwood.jpg",
      alt:'Dec-Tec membrane in various applications and settings 30'
    },

  ]


  return (
    <div>
      <SliderGallery
        title="Coolstep Sandalwood"
        para1="As one of the newest members of our CoolStep Line, this membrane combines all the features of our 80 mil CoolStep with a high definition wood-grain pattern. Without a doubt, CoolStep Sandalwood is the coolest solution for locations that get a lot of sun! "
        galleryImages={galleryImages}
        previouslink="/coolstep-copper-gallery/"
        nextlink="/coolstep-slate-gallery/"
      />
    </div>
  )
}

export default CoolstepSandalwoodGallery
